<template>
  <div v-loading="loading" class="activity-detail">
    <div class="my-page-head">
      <el-page-header content="活动详情" @back="goBack" />
      <ul class="page-head-ul">
        <li v-for="(item, index) in pageHeaderArr" :key="item.title + index">
          <label>{{ item.title }}:</label>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>

    <h2 class="detail-title">
      {{ detailData.title }}
    </h2>
    <div class="detail-info">
      <span><i class="el-icon-time" />&nbsp;&nbsp;{{ detailData.startTime }}&nbsp;至&nbsp;{{ detailData.endTime }}</span>
      <el-divider direction="vertical" />
      <span v-if="+detailData.isOnline === 0" class="address ellipsis" :title="detailData.address"><i class="el-icon-location-outline" /> {{ detailData.address }}</span>
      <span v-else class="address"><i class="el-icon-location-outline" /> 线上</span>
    </div>
    <div class="content-main" v-html="detailData.content"></div>

    <div class="optinos">
      <div v-if="detailData.isApply == 1">
        <!-- 报名状态 -->
        <!-- <div v-if="detailData.userApply === -2" class="link-btn" disabled>报名失败</div>
        <div v-if="detailData.userApply === 1" class="link-btn" disabled>报名成功</div> -->
        <!-- 活动是否过期 -->
        <template v-if="detailData.expired">
          <div v-if="detailData.userApply == 1 || detailData.userApply == -2" class="link-btn disabled">取消参与</div>
          <div v-else class="link-btn disabled">参与报名</div>
        </template>
        <template v-else>
          <div v-if="detailData.userApply === 0" class="link-btn" @click="cancelActSignUp(detailData.id)">取消参与</div>
          <div v-if="detailData.userApply === -1" class="link-btn" style="background-color: #b81c22; color: #fff" @click="signApply(detailData.id, detailData.userApply)">
            参与报名
          </div>
          <div v-if="detailData.userApply == 1 || detailData.userApply == -2" class="link-btn disabled">取消参与</div>
        </template>

        <div v-if="detailData.isAssessment == 1" class="link-btn" @click="RouterToActivityAssetssment(detailData.id, 'activity')">
          {{ detailData.assessmentState ? '查看评估' : '活动评估' }}
        </div>

        <!-- <div v-if="detailData.isHpAssessment == 1" class="link-btn" @click="RouterToActivityAssetssment(detailData.id, 'acthp')">
          {{ detailData.hpAssessmentState ? '查看互评' : '活动互评' }}
        </div> -->
        <div v-if="detailData.isFull" class="tips">活动报名人数已满</div>
      </div>
      <span v-if="detailData.isFull" class="tips">活动报名人数已满</span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Router from '@/router'
import API from '@/api'
import { Message, MessageBox, Loading } from 'element-ui'

const loading = ref(false)
const pageHeaderArr = ref([
  {
    title: '学年',
    value: '-'
  },
  {
    title: '学期',
    value: '-'
  },
  {
    title: '教学周',
    value: '-'
  }
])
/* 获取当前学年、学期、周数 */
function getSchoolCalendar() {
  API.Semester().then(res => {
    if (+res.code === 200) {
      const { semester, schoolYear, week } = res.data
      const data = [
        {
          title: '学年',
          value: schoolYear || '-'
        },
        {
          title: '学期',
          value: semester || '-'
        },
        {
          title: '教学周',
          value: week ? `第${week}周` : '-'
        }
      ]
      pageHeaderArr.value = data
    }
  })
}

// 获取详情数据
const detailData = ref({})
function getDetail(id) {
  loading.value = true
  API.activityDetail({ id })
    .then(res => {
      if (+res.code === 200) {
        detailData.value = res.data
      }
      loading.value = false
    })
    .catch(_ => {
      loading.value = false
    })
}

// 返回
function goBack() {
  Router.go(-1)
}

// 报名
function signApply(id) {
  const loading = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)'
  })
  API.actSignUp({ id }).then(res => {
    loading.close()
    if (+res.code === 200) {
      Message.success(res.msg)
      getDetail(id)
    } else {
      Message.error(res.msg)
    }
  })
}

// 取消参与
function cancelActSignUp(id) {
  MessageBox.confirm(`您确定要取消参与该活动吗？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      API.cancelActSignUp({ id }).then(res => {
        if (+res.code === 200) {
          Message.success(res.msg)
          getDetail(id)
        }
      })
    })
    .catch(() => {
      console.log('取消')
    })
}

function RouterToActivityAssetssment(id, type) {
  if (!id) return
  Router.push({
    name: 'ActivityAssessment',
    params: { id },
    query: { type: 'activity' }
  })
}

onMounted(() => {
  const { params } = Router.currentRoute
  getSchoolCalendar()

  if (params && params.id) {
    getDetail(params.id)
  }
})
</script>

<style lang="scss" scoped>
.my-page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

ul.page-head-ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  padding: 0;

  li {
    list-style: none;

    label {
      font-size: 16px;
      color: #777;
      margin-right: 10px;
    }

    span {
      font-size: 16px;
      color: #333;
    }

    &:not(:last-child) {
      margin-right: 60px;
    }
  }
}

.detail-title {
  font-size: 20px;
  text-align: center;
}

.detail-info {
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 20px;
  padding-bottom: 24px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.content-main {
  margin: 0 auto;
  min-height: 40vh;
}

.optinos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 30px;
  margin-bottom: 50px;
  border-top: 1px solid #eee;
  padding-top: 50px;
  .tips {
    margin-top: 16px;
    color: var(--theme-color);
    font-size: 14px;
  }

  .link-btn {
    display: inline-block;
    margin-right: 30px;
    height: 40px;
    color: #ffffff;
    background-color: #b22222;
    border-color: #b22222;
    line-height: 1;
    white-space: nowrap;
    text-align: center;
    box-sizing: border-box;
    transition: 0.1s;
    font-weight: 400;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;

    &.disabled {
      background-color: #bbb !important;
      border-color: #bbb !important;
    }
  }
}
</style>

<style>
img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
